import Cookies from 'js-cookie';

import { API_BASE_URI } from '@components/env';
import { type Cookie, cookies } from '@shared/cookies';
import { parseDomain } from '@shared/utils/parseDomain';
import type { Cookies as ServerCookies } from '@sveltejs/kit';

import { browser } from '$app/environment';

export function setCookie(cookie: Cookie, value: string | null, serverCookies?: ServerCookies): void {
    const client = getClient(serverCookies);
    const attributes = getAttributes(cookie);
    if (value === null) {
        client.delete(cookie, attributes);
    } else {
        client.set(cookie, value, attributes);
    }
}

export function getCookie(cookie: Cookie, serverCookies?: ServerCookies): string | undefined {
    const client = getClient(serverCookies);
    return client.get(cookie);
}

function getClient(serverCookies?: ServerCookies) {
    if (!browser && !serverCookies) {
        throw new Error('Cookies is not allowed');
    }

    return {
        get: serverCookies?.get.bind(serverCookies) ?? Cookies.get.bind(Cookies),
        set: serverCookies?.set.bind(serverCookies) ?? Cookies.set.bind(Cookies),
        delete: serverCookies?.delete.bind(serverCookies) ?? Cookies.remove.bind(Cookies),
    };
}

function getAttributes(cookie: Cookie): {
    httpOnly: boolean;
    expires: Date;
    path: string;
    domain?: string;
} {
    const attributes = cookies[cookie];
    return {
        expires: new Date(Date.now() + attributes.expires),
        path: '/',
        httpOnly: false,
        ...(attributes.needOnBackend ? { domain: parseDomain(API_BASE_URI) } : {}),
    };
}
